import { Suspense, lazy } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Lazy load heavy components
export const ROICalculatorLazy = lazy(() => import('@/components/landing/ROICalculator'));
export const ProcessTimelineLazy = lazy(() => import('@/components/landing/ProcessTimeline'));
export const FAQLazy = lazy(() => import('@/components/landing/FAQ'));

// Optimized loading skeletons
const ROICalculatorSkeleton = () => (
  <section className="py-16 bg-muted/30">
    <div className="container mx-auto px-4">
      <div className="max-w-4xl mx-auto">
        <Skeleton className="h-12 w-3/4 mx-auto mb-6" />
        <Skeleton className="h-6 w-1/2 mx-auto mb-12" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-6">
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-16 w-full" />
          </div>
          <div className="space-y-4">
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-12 w-2/3" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

const ProcessTimelineSkeleton = () => (
  <section className="py-16">
    <div className="container mx-auto px-4">
      <Skeleton className="h-12 w-2/3 mx-auto mb-6" />
      <Skeleton className="h-6 w-1/2 mx-auto mb-12" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="h-16 w-16 rounded-full mx-auto" />
            <Skeleton className="h-6 w-3/4 mx-auto" />
            <Skeleton className="h-16 w-full" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

const FAQSkeleton = () => (
  <section className="py-16">
    <div className="container mx-auto px-4 max-w-4xl">
      <Skeleton className="h-12 w-1/2 mx-auto mb-12" />
      <div className="space-y-4">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className="h-16 w-full" />
        ))}
      </div>
    </div>
  </section>
);

// Wrapper components with Suspense
export const ROICalculatorWrapper = () => (
  <Suspense fallback={<ROICalculatorSkeleton />}>
    <ROICalculatorLazy />
  </Suspense>
);

export const ProcessTimelineWrapper = () => (
  <Suspense fallback={<ProcessTimelineSkeleton />}>
    <ProcessTimelineLazy />
  </Suspense>
);

export const FAQWrapper = () => (
  <Suspense fallback={<FAQSkeleton />}>
    <FAQLazy />
  </Suspense>
);